import { Component, OnInit, Input, EventEmitter, Output, forwardRef, ViewEncapsulation, OnDestroy } from '@angular/core';
import { NG_VALUE_ACCESSOR } from '@angular/forms';
import { IdService, FormControlBase } from '../../shared/index';

@Component({
	selector: 'rbc-radio',
	templateUrl: './radio.component.html',
	styleUrls: ['./radio.component.scss'],
	encapsulation: ViewEncapsulation.None,
	providers: [
		{
			provide: NG_VALUE_ACCESSOR,
			multi: true,
			useExisting: forwardRef(() => RadioComponent)
		}
	]
})
export class RadioComponent extends FormControlBase<string> implements OnDestroy {
	id: string;

	@Input() disabled: boolean | string;
	@Input('name') name: string;
	@Input('value') value: string;
	@Output() radioUpdate = new EventEmitter();

	constructor(private idService: IdService) {
		super();
		this.id = idService.generate();
	}

	ngOnDestroy(): void {
		this.idService.remove(this.id);
		super.ngOnDestroy();
	}

	setModel(value: string) {
		this.innerValue = value;
		this.changed(value);
	}

	checkSelected() {
		if (this.innerValue === this.value) {
			return true;
		}
		return false;
	}

	toggleHandler() {
		this.radioUpdate.emit({ name: this.name, checked: this.innerValue });
	}
}
